
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
  import {
    freightSettlementTemplatefreightSettlementTemplateRecord
  } from "@/api/order"
  @Component({  
    name: '',
    components: {
      PageFooter
    }
  })

  export default class ProductList extends Vue {
    private shop = {
      Name:decodeURIComponent((this as any).$route.query.Name),
      Img:decodeURIComponent((this as any).$route.query.Img),
    }
    private list:any = []
    private typelist = [
      {value:1,label:'员工'},
      {value:2,label:'客户'},
      {value:3,label:'供货商'},
      {value:4,label:'分销员'},
      {value:5,label:'系统'},
    ]


    private mounted () {
      this.getData()
    }
    private async getData(){
      try{
        let res = await freightSettlementTemplatefreightSettlementTemplateRecord({
          ProductId:this.$route.query.Id
        })
        if(res.IsSuccess){
          this.list = res.Result.map(v=>{
            v.OperatorTypeValue = this.typelist.find(x=>x.value==v.OperatorType)?.label
            return v
          })
        }
      }finally{
        //
      }
    }
  }
